import { Pipe, PipeTransform } from '@angular/core';
import { CoreNiceLabelUtils } from '../core-nice-label.utils';

export enum SendStatus {
  PENDING = 'pending',
  SENT = 'sent',
  CANCELED = 'canceled',
}

@Pipe({
  name: 'sendStatusDisplay',
})
export class SendStatusDisplayPipe implements PipeTransform {
  transform(value: SendStatus): string {
    return sendDisplayTransform(value);
  }
}

export function sendDisplayTransform(value: SendStatus) {
  return CoreNiceLabelUtils.sendStatus(value);
}
